import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
  name: 'parseVariantName',
})
export class ParseVariantName implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) { }
  transform(variant: any) {
    const match = variant.name.match(/^(.+?) - цена: (.+)$/);
    if (match && variant.appliedDiscountType && variant.priceOnDiscount && variant.priceOnDiscount != variant.price) {
      return match[1] + ` ${variant.priceOnDiscount.toFixed(2)} ➡ ${variant.price.toFixed(2)} (${this.diff(variant.price - variant.priceOnDiscount)})`;
    }
    return name;
  }

  diff(price: number) {
    const decimalPipe = new DecimalPipe(this.locale);
    const plus = price > 0 ? '+' : '';
    return plus + decimalPipe.transform(price, '1.0-0');
  }
}
